module.exports = __webpack_public_path__ + "static/media/couperendmaintenancecream.54653794.png";